import { Box, Typography, Divider } from '@mui/material';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import { RADIUS } from '../../../layouts/dashboard/config-layout';
import Header from './components/destination.header';
import DestinationTable from './components/destination.table';
import MinistryController from '../controllers/ministry.controller';
import { useEffect } from 'react';
import { DestinationModalNames } from '../data/destination.modal.name.tsx';
import DestinationModalView from './components/destination.modal.view';
import ProvinceModalCreate from './components/province.modal.create';
import ProvinceModalUpdate from './components/province.modal.update';
import CusttomAlertController from '../../../alert/controller/custom.alert.controller';
import CustomAlertModal from '../../../alert/components/custom.alert.modal';
import useScreenWidth from '../../../hooks/use-page-width';

const LABEL = 'ກະຊວງ';

const DestinationMinistryPage = () => {
  const ctrl = MinistryController();
  const alert = CusttomAlertController();
  const width = useScreenWidth();

  useEffect(() => {
    ctrl.getData(true, ctrl.filter);
  }, []);

  return (
    <>
      <Typography sx={{ px: 3, py: 2, color: '#f5f4f4' }}>ຈັດການ{LABEL}</Typography>

      <Box sx={{ px: width > 600 ? 3 : 0, paddingBottom: '15px' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f5f4f4',
            borderTopLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderTopRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
          }}
        >
          <Box>
            <Header
              ctrl={ctrl}
              label={LABEL}
              handleOpenDialog={() => ctrl.onHandleModal({ name: DestinationModalNames.CREATE })}
            />

            <Divider sx={{ backgroundColor: '#D9D9D9' }} />

            <Typography
              fontSize={18}
              sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', p: 3 }}
            >
              <HomeWorkOutlinedIcon />
              <Typography marginLeft="10px">ຈັດການ{LABEL}</Typography>
            </Typography>

            <DestinationTable ctrl={ctrl} alert={alert} label={LABEL} />
          </Box>
        </Box>
      </Box>

      <DestinationModalView
        activeModal={ctrl.activeModal}
        onClose={() => ctrl.onHandleModal(null)}
        createContent={
          <ProvinceModalCreate
            label={LABEL}
            loading={ctrl.loading}
            message={ctrl.message}
            onClose={() => ctrl.onHandleModal(null)}
            onSubmit={ctrl.onSubmitCreate.bind(ctrl)}
          />
        }
        updateContent={
          <ProvinceModalUpdate
            label={LABEL}
            loading={ctrl.loading}
            message={ctrl.message}
            defaultValues={ctrl.formUpdate}
            onClose={() => ctrl.onHandleModal(null)}
            onSubmit={ctrl.onSubmitUpdate.bind(ctrl)}
          />
        }
      />

      <CustomAlertModal ctrl={alert} />
    </>
  );
};

export default DestinationMinistryPage;
